import { __awaiter } from "tslib";
import { getWorkerString } from '../workers/session-recording-worker';
export class WorkerManager {
    loadAndCreateWorker(workerUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const workerCode = workerUrl
                    ? yield this.loadWorkerScript(workerUrl)
                    : `(${getWorkerString.toString()})()`;
                const workerBlob = new Blob([workerCode], {
                    type: 'application/javascript',
                });
                const blobUrl = URL.createObjectURL(workerBlob);
                return new Worker(blobUrl);
            }
            catch (error) {
                console.warn(`CoralogixRum: Error creating worker ${error}`);
                return undefined;
            }
        });
    }
    loadWorkerScript(url) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield fetch(this.getFullWorkerUrl(url));
                if (!response.ok) {
                    console.warn(`CoralogixRum: Error fetching custom web worker`);
                    return '';
                }
                return yield response.text();
            }
            catch (error) {
                console.warn(`CoralogixRum: Error fetching custom web worker`);
                return '';
            }
        });
    }
    getFullWorkerUrl(workerUrl) {
        if (workerUrl.startsWith('http://') || workerUrl.startsWith('https://')) {
            return workerUrl;
        }
        return `${window.location.origin}${workerUrl}`;
    }
}
